<template>
  <div class="col-md-10">
    <div class="row">
      <div @click="analits(evento.sc_interno ?evento.sc_interno:evento.sc_externo)" v-for="(item,index) in ingressos" :key="index" class="col-xl-3 col-lg-6 col-sm-4 col-md-3 col-12">
        <div class="card" :class="item.cor">
          <div class="card-statistic-3 p-3">
            <div class="card-icon card-icon-large">
              <i class="fas fa-ticket-alt"></i>
            </div>
            <div class="mb-4">
              <h5 class="card-title mb-0 text-uppercase" style="color: white">
               {{ item.tipo}} - {{ item.obs }} 
              </h5>
            </div>
            <div class="row align-items-center mb-2 d-flex">
              <div class="col-6">
                <h2 class="d-flex align-items-center mb-0" style="color: white">
                    R${{ item.valor.replace(".", ",") }}
                </h2>
              </div>
              <div class="col-6 text-right text-uppercase " style="font-size: 14px;">
                {{ item.tipo2}}
                <!-- <span>{{ item.obs }}  -->
                    <!-- <i class="fas fa-arrow-up"></i> -->
                <!-- </span> -->
              </div>
            </div>
            <!-- <div class="progress mt-1" data-height="8" style="height: 8px">
              <div
                class="progress-bar l-bg-orange"
                role="progressbar"
                data-width="25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
                style="width: 25%"
              ></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["ingressos","evento"],

  data() {
    return {};
  },

  methods:{
    async analits(link) {
      // await this.sleep(300);
      // this.$store.dispatch("evento/set_msn_compra", 'então bora lá' )
      // await this.sleep(2000);


      window.open(link, "_blank");
      // this.modals.modal1 = true;
      // this.$store.dispatch("evento/analitsEvento", {
      //   eventos_id: this.$route.params.id,
      // });
      // this.$store.dispatch("evento/set_msn_compra", 'COMPRAR' )

    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
  }
};
</script>

<style>
.card {
  background-color: #fff;
  border-radius: 10px;
  border: none;
  color: white;
  position: relative;
  margin-bottom: 10px;
  box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1),
    0 0.9375rem 1.40625rem rgba(0, 95, 203, 0.1),
    0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12),
    0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);
}
.l-bg-cherry {
  background: linear-gradient(to right, #493240, #f09) !important;
  color: #fff;
}

.l-bg-blue-dark {
  background: linear-gradient(to right, #373b44, #4286f4) !important;
  color: #fff;
}

.l-bg-green-dark {
  background: linear-gradient(to right, #0a504a, #38ef7d) !important;
  color: #fff;
}

.l-bg-orange-dark {
  background: linear-gradient(to right, #a86008, #ffba56) !important;
  color: #fff;
}

.card .card-statistic-3 .card-icon-large .fas,
.card .card-statistic-3 .card-icon-large .far,
.card .card-statistic-3 .card-icon-large .fab,
.card .card-statistic-3 .card-icon-large .fal {
  font-size: 110px;
}

.card .card-statistic-3 .card-icon {
  text-align: center;
  line-height: 50px;
  margin-left: 15px;
  color: #000000;
  position: absolute;
  right: -5px;
  top: 20px;
  opacity: 0.2;
}

.l-bg-cyan {
  background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
  color: #fff;
}

.l-bg-green {
  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%) !important;
  color: #fff;
}

.l-bg-orange {
  background: linear-gradient(to right, #f9900e, #ffba56) !important;
  color: #fff;
}

.l-bg-cyan {
  background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
  color: #fff;
}
</style>